import React, { useState, useEffect, useContext } from "react";
import { MdLocationOn } from "react-icons/md";
import "./SearchSection.css"; // Import external CSS for animation
import { useNavigate } from "react-router-dom";
import { SearchContext } from "../../../context/SearchContext";
 
const SearchSection = () => {
  const words = ["Veterinary", "Groomer", "Boarder"];
  const [index, setIndex] = useState(0);
  const navigate = useNavigate();
 
  // Context state
  const { pincode, setPincode, fetchVendors, loading, error } =
    useContext(SearchContext);
 
  // Word animation
  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % words.length);
    }, 2500);
    return () => clearInterval(interval);
  }, []);
 
  // Handle vendor fetch
  const handleFetch = async () => {
    console.log("abcdsfrfg");
    const result = await fetchVendors(17); // Use context fetchVendors with radius 17
    if (result) {
      navigate("/shop-detail", { state: { vendors: result.data || result } });
    }
  };
 
  return (
    <div className="flex flex-col items-center justify-center min-h-[50vh]  px-4 sm:px-6 lg:px-8 w-full max-w-7xl mx-auto">
      {/* Heading */}
      <div className="text-center">
        <p className="text-3xl sm:text-4xl lg:text-6xl font-semibold font-[lora] text-[#000048] flex flex-wrap justify-center items-center gap-2">
          Find & Book Local Pet{"  "}
          <span className="word-wrapper">
            {/* Invisible longest word for fixed width */}
            <span className="invisible">
              {words.reduce((a, b) => (a.length > b.length ? a : b), "")}
            </span>
            {/* Animated word */}
            <span
              key={index}
              className="animated-word text-3xl sm:text-4xl lg:text-6xl font-semibold font-[lora] text-[#000048] tracking-wide sm:tracking-tightest xs:tracking-tightest"
            >
              {words[index]}
            </span>
          </span>
        </p>
        <p className="text-3xl sm:text-4xl lg:text-5xl font-semibold font-[lora] text-[#000048] mt-2">
          Near You
        </p>
      </div>
 
      {/* Search bar */}
      <div className="flex flex-col sm:flex-row justify-center items-center mt-10 w-full max-w-lg gap-3">
        <div className="relative flex items-center w-full max-w-xs">
          <MdLocationOn className="absolute left-3 text-[#ffa500] w-6 h-6" />
          <input
            type="number"
            value={pincode || ""}
            onChange={(e) => setPincode(e.target.value)}
            placeholder="Enter pin code"
            className="w-full pl-10 pr-4 py-2.5 border-4 border-[#dbdbe5] rounded-md focus:outline-none focus:ring-2 focus:ring-[#bbbaba] text-sm sm:text-base placeholder-[#000048] bg-white shadow-sm transition-all duration-200 [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
            onKeyDown={(e) => {
              if (["e", "E", "+", "-"].includes(e.key)) {
                e.preventDefault();
              }
              if (e.key === "Enter") handleFetch();
            }}
          />
        </div>
        <button
          onClick={handleFetch}
          disabled={loading}
          className={`flex items-center gap-2 bg-[#ff6216] text-white px-5 py-2.5 font-semibold rounded-md text-lg sm:text-xl transition-all duration-150 shadow-md ${
            loading
              ? "opacity-50 cursor-not-allowed"
              : "hover:bg-[#e05514] hover:shadow-lg"
          }`}
        >
          {loading ? "Fetching..." : "Fetch"}
          <span className="text-2xl font-bold">→</span>
        </button>
      </div>
 
      {/* Error message */}
      {error && (
        <div className="mt-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded-md text-sm sm:text-base max-w-lg w-full text-center shadow-sm">
          {error}
        </div>
      )}
    </div>
  );
};
 
export default SearchSection;